import styled from "@emotion/styled";
import { FontSizeInPx, FontWeight } from "@snapchat/snap-design-system";

export const RejectionErrorsPanelV2ModalTriggerTextContainer = styled.span`
    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.MEDIUM};
`;
